import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Compass } from 'lucide-react';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="container mx-auto flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <Compass className="h-16 w-16 text-text-muted" aria-hidden />
      <h1 className="mt-4 text-5xl font-bold text-text-primary">404</h1>
      <p className="mt-2 text-text-secondary">{t('notFound.titulo')}</p>
      <p className="mt-1 text-sm text-text-muted">{t('notFound.subtitulo')}</p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-md bg-accent px-4 py-2 font-medium text-accent-contrast hover:opacity-90"
      >
        {t('notFound.volver')}
      </Link>
    </main>
  );
}

export default NotFoundPage;
